import { useNavigate } from "react-router-dom";
import { RoutePath } from "@/section/router";
import { SendDestinationEnvelopeFormCore } from "../components/SendDestinationEnvelopeFormCore";

export function DestinationPacketsSendEnvelopePage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-sm text-muted-foreground uppercase tracking-wide">
            Destination Packets
          </p>
          <h2 className="text-2xl font-bold">Send Envelope</h2>
        </div>
      </div>

      <SendDestinationEnvelopeFormCore
        onSuccess={() => navigate(RoutePath.DestinationPacketsTemplates)}
        onCancel={() => navigate(RoutePath.DestinationPacketsTemplates)}
      />
    </div>
  );
}

